module.exports = __webpack_public_path__ + "img/icon-calendar-dark-grey.eb6fdfac.svg";